import PlaceholderScreen from '../../components/PlaceholderScreen/PlaceholderScreen'

export default function BetterLifeScreen() {
  return <PlaceholderScreen title="Better Life Records" />
}